import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import "../../../assets/scss/other-settings.scss";
import { usePermission } from '../../helpers/common';
import { Icon } from '../widgets';
import Farm from './Farm';
import MessageAlert from './MessageAlert';
import Notification from './Notification';
import User from './User';

const Settings = () => {

  const allow = usePermission();
  const [selectedSetting, setSelectedSettings] = useState("user");
  const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
  const isAllowUserView = allow('user-settings', 'view');
  const isAllowNotificationView = allow('notification-settings', 'view');
  const isAllowFarmView = allow('farm-settings', 'view');

  const settingsList = [
    { value: 'user', name: 'user', label: "User", icon: "fa fa-user", visible: isAllowUserView },
    { value: 'farm', name: 'farm', label: "Farm", icon: "icon icon-field", visible: isAllowFarmView },
    { value: 'sms', name: 'sms', label: "SMS", icon: "fa fa-envelope", visible: isAllowNotificationView },
    { value: 'notification', name: 'notification', label: "Notification", icon: "fa fa-bell", visible: isAllowNotificationView },
  ];

  useEffect(() => {
    if (isAllowUserView) setSelectedSettings('user')
    else if (isAllowFarmView) setSelectedSettings('farm')
    else if (isAllowNotificationView) setSelectedSettings('notification')
    else setSelectedSettings('sms')
  }, []);

  const handleSetting = (selectedSetting) => {
    setSelectedSettings(selectedSetting);
  };

  return (
    <div className='other-settings-container'>
      <div className='inner-container'>
        <div className='left-tab'>
          {
            settingsList.filter((setting) => {
              return setting.visible === true;
            }).map((item, index) => {
              return (
                <div key={index} className={`settings-card ${selectedSetting === item.value ? "selected" : ''}`} onClick={() => handleSetting(item.name)}>
                  <span className='mr-2 ml-2'><Icon className={item.icon} /></span>
                  {item.label}
                </div>
              )
            })
          }
        </div>
        <div className='right-tab'>
          {selectedSetting === "user" && isAllowUserView && <User />}
          {selectedSetting === "farm" && isAllowFarmView && <Farm />}
          {selectedSetting === "sms" && isAllowNotificationView && <MessageAlert />}
          {selectedSetting === "notification" && isAllowNotificationView && <Notification farmId={farmId} />}
        </div>
      </div>
    </div>
  )
}

export default Settings